const OWNER_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
const CRITICALITY_VALUES = new Set(['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'])

export const CRITICALITY_EMPTY_LABEL = 'assets.add.noCriticality'

export const PROPOSAL_COLUMN_WIDTH = {
  select: '2.75rem',
  name: '18%',
  project: '16%',
  kind: '10%',
  category: '14%',
  zone: '12%',
  ip: '12%',
  status: '12%',
  actions: '14%',
}

export function proposalTableColumns(kind) {
  const columns = ['select', 'name', 'project', 'category', 'zone', 'ip', 'status', 'actions']
  if (kind !== 'INSTANCE') columns.splice(3, 0, 'kind')
  return columns
}

export function categoryPresentation(category) {
  if (category === 'SERVERS') return { labelKey: 'gcpProposals.serverVm', fallback: 'Server / VM' }
  return { labelKey: null, fallback: category || null }
}

export function proposalActionVisibility(status) {
  return {
    addSelected: status === 'NEW',
    addMatching: status === 'NEW',
    ignore: status === 'NEW',
    restore: status === 'IGNORED',
  }
}

export function showServerCategoryAction(rows) {
  return rows.some((row) => row?.proposedCategory !== 'SERVERS')
}

export const MATCHING_REGISTRATION_LIMIT = 100

export function matchingRegistrationCount(counts) {
  const value = Number(counts?.pendingVms)
  if (!Number.isFinite(value) || value < 0) return 0
  return Math.min(Math.trunc(value), MATCHING_REGISTRATION_LIMIT)
}

export function filterProposalRows(items, query) {
  const needle = String(query || '').trim().toLowerCase()
  if (!needle) return items
  return items.filter((row) => [row?.resourceName, row?.projectId, row?.ip, row?.location]
    .some((value) => String(value || '').toLowerCase().includes(needle)))
}

export function registrationBody({ mode, ids, kind, environment, criticality, ownerId }) {
  const body = {
    environment: environment || 'PRODUCTION',
    criticality: CRITICALITY_VALUES.has(criticality) ? criticality : null,
  }
  if (ownerId && OWNER_ID_RE.test(String(ownerId))) body.ownerId = ownerId
  if (mode === 'all') {
    body.allMatching = true
    body.filters = { kind: kind || undefined }
    return body
  }
  body.ids = ids
  return body
}
